import { useEffect, useState } from "react";

function Cart() {
  const [cart, setCart] = useState([]);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    fetch(`https://ecommerce-backend-ya7x.onrender.com/api/cart/${user._id}`)
      .then(res => res.json())
      .then(data => setCart(data.products || []));
  }, []);

  const removeItem = async (index) => {
    const user = JSON.parse(localStorage.getItem("user"));
    await fetch("https://ecommerce-backend-ya7x.onrender.com/api/cart", {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userId: user._id, index }),
    });
    setCart(prev => prev.filter((_, i) => i !== index));
  };

  const updateQty = (index, delta) => {
    setCart(prev =>
      prev.map((item, i) =>
        i === index ? { ...item, quantity: Math.max(1, (item.quantity || 1) + delta) } : item
      )
    );
  };

  const placeOrder = async () => {
  const user = JSON.parse(localStorage.getItem("user"));

  console.log("Sending order:", {
    userId: user._id,
    products: cart,
    total,
  });

  try {
    const res = await fetch("https://ecommerce-backend-ya7x.onrender.com/api/orders", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        userId: user._id,
        products: cart,
        total,
      }),
    });

    const data = await res.json();

    if (!res.ok) {
      console.log(data);
      alert("Order failed");
      return;
    }

    // clear cart after success
    await fetch("https://ecommerce-backend-ya7x.onrender.com/api/cart/clear", {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ userId: user._id }),
    });

    setCart([]);
    alert("Order placed!");
  } catch (err) {
    console.log(err);
    alert("Error placing order");
  }
};

  const total = cart.reduce((sum, item) => sum + item.price * (item.quantity || 1), 0);

  return (
    <div className="min-h-screen bg-[#0d0d0f] text-white [font-family:'Syne',sans-serif]">
      <link href="https://fonts.googleapis.com/css2?family=Syne:wght@400;500;600;700&display=swap" rel="stylesheet" />

      <section className="max-w-3xl mx-auto px-4 sm:px-6 py-10">

        {/* Header */}
        <div className="border-b border-white/5 pb-6 mb-6">
          <p className="text-[0.65rem] font-medium tracking-[0.22em] uppercase text-[#6f5bff] mb-3">
            Checkout
          </p>
          <div className="flex items-center justify-between">
            <h1 className="text-3xl font-semibold tracking-tight">Your Cart</h1>
            <span className="text-sm text-gray-400 font-medium">{cart.length} items</span>
          </div>
        </div>

        {/* Empty state */}
        {cart.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-24 gap-3">
            <svg className="w-10 h-10 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 3h1.386c.51 0 .955.343 1.087.836l.383 1.437M7.5 14.25h9.75m-9.75 0a1.5 1.5 0 01-1.5 1.5 1.5 1.5 0 001.5 1.5m0-3a1.5 1.5 0 001.5 1.5m9.75-1.5a1.5 1.5 0 01-1.5 1.5 1.5 1.5 0 001.5 1.5m0-3a1.5 1.5 0 001.5 1.5M6.107 5.273L7.5 14.25m0 0H5.625" />
            </svg>
            <p className="text-gray-600 text-sm">Your cart is empty</p>
          </div>
        ) : (
          <>
            <div className="flex flex-col gap-3 mb-8">
              {cart.map((item, index) => (
                <div
                  key={index}
                  className="flex items-center gap-4 bg-[#141416] border border-white/[0.07] rounded-[10px] p-3 sm:p-4
                    hover:border-[#6f5bff]/30 transition-all duration-200"
                >
                  {/* Image */}
                  <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-lg shrink-0 flex items-center justify-center
                    [background:radial-gradient(ellipse_at_50%_70%,#1e1b35_0%,#111113_100%)]">
                    {item.image ? (
                      <img src={item.image} alt={item.name} className="h-full object-contain p-1" />
                    ) : (
                      <svg className="w-5 h-5 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 7.5l-9-5.25L3 7.5m18 0l-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25" />
                      </svg>
                    )}
                  </div>

                  {/* Info */}
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm font-medium text-white truncate">{item.name}</h3>
                    <p className="text-xs text-gray-500 mt-0.5">₹{item.price} each</p>

                    {/* Quantity controls */}
                    <div className="flex items-center gap-2 mt-2">
                      <button
                        onClick={() => updateQty(index, -1)}
                        className="w-6 h-6 rounded-md bg-[#1e1b35] border border-white/5 flex items-center justify-center
                          text-gray-400 hover:text-white hover:border-[#6f5bff]/40 transition-all duration-150 text-sm leading-none"
                      >
                        −
                      </button>
                      <span className="text-sm font-medium text-white w-4 text-center">
                        {item.quantity || 1}
                      </span>
                      <button
                        onClick={() => updateQty(index, 1)}
                        className="w-6 h-6 rounded-md bg-[#1e1b35] border border-white/5 flex items-center justify-center
                          text-gray-400 hover:text-white hover:border-[#6f5bff]/40 transition-all duration-150 text-sm leading-none"
                      >
                        +
                      </button>
                    </div>
                  </div>

                  {/* Price + Remove */}
                  <div className="flex flex-col items-end gap-2 shrink-0">
                    <p className="text-sm font-semibold text-[#8b7dff]">
                      ₹{item.price * (item.quantity || 1)}
                    </p>
                    <button
                      onClick={() => removeItem(index)}
                      className="flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-medium text-gray-500
                        border border-white/[0.07] rounded-md bg-[#1a1a1c]
                        hover:text-red-400 hover:border-red-500/30 hover:bg-red-500/5
                        transition-all duration-200 group"
                    >
                      <svg className="w-3.5 h-3.5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                      Remove
                    </button>
                  </div>
                </div>
              ))}
            </div>

            {/* Total + CTA */}
            <div className="bg-[#141416] border border-white/[0.07] rounded-[10px] p-4 sm:p-5">
              <div className="flex items-center justify-between mb-4">
                <span className="text-sm text-gray-400">Subtotal</span>
                <span className="text-sm font-semibold text-white">₹{total}</span>
              </div>
              <div className="flex items-center justify-between pb-4 border-b border-white/5 mb-4">
                <span className="text-sm text-gray-400">Shipping</span>
                <span className="text-xs text-green-500 font-medium">Free</span>
              </div>
              <div className="flex items-center justify-between mb-5">
                <span className="text-sm font-semibold text-white">Total</span>
                <span className="text-base font-semibold text-[#8b7dff]">₹{total}</span>
              </div>
              <button
                onClick={placeOrder}
                className="w-full py-2.5 text-white text-[0.8rem] font-semibold tracking-[0.04em]
                  bg-[#6f5bff] rounded-md hover:bg-[#8472ff] active:scale-[0.98]
                  transition-all duration-200 ease-in-out">
                Order Now
              </button>
            </div>
          </>
        )}
      </section>
    </div>
  );
}

export default Cart;